/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import React from "react";

import { headerDesignForSp, resetButtonStyles } from "./HeaderSpDisplay";

type Props = {
  uid: string;
  isDisplayLogo: boolean;
  domainLogo: JSX.Element;
  HeaderMenuItems: { name: string; link: string; display: boolean }[];
  toggleLoginMethod: () => void;
};
export const HeaderRedeemerDisplay: React.FC<Props> = (props) => {
  const classesHeaderForSp = headerDesignForSp();

  return (
    <header css={classesHeaderForSp.header}>
      <div css={classesHeaderForSp.container}>
        <div />

        {props.isDisplayLogo && (
          <h1 css={classesHeaderForSp.logo}>{props.domainLogo}</h1>
        )}

        <div css={classesHeaderForSp.iconList}>
          {!props.uid && (
            <button
              id="login"
              css={resetButtonStyles}
              className={"putBadge"}
              onClick={props.toggleLoginMethod}
            >
              <ExitToAppIcon aria-label="Login" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
